export default __webpack_public_path__ + "static/image_acceuil_s@2x-aad452691422f415681bf7eb8ee5d70c.jpg";